export default __webpack_public_path__ + "static/images/pngIcon.26c4f15c.svg";